module.exports = __webpack_public_path__ + "img/HelpNull.072d9c7f.svg";